import { render, staticRenderFns } from "./BadgesMobileFooterActions.vue?vue&type=template&id=9a370474"
import script from "./BadgesMobileFooterActions.vue?vue&type=script&lang=js"
export * from "./BadgesMobileFooterActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports